import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Link, Stack, TextField, Typography, useTheme } from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { EGSwitch } from "../../../../MainComponents/Switch/Switch";
import { HelpIcon } from "../../../../MainComponents/HelpIcon/HelpIcon";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { EvaluationListItem } from "./EvaluationListItem";
import { returnIsValid } from "../Main/useConstants";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";
import { InputCatalogue } from "../../../../MainComponents/Catalogues/InputCatalogue";
import { resolveCatalogueLabel } from "../../../../../helpers/catalogueLabel";

// Lista de acciones o politicas
export const EvaluationList = ({
  id,
  data,
  questionLabel,
  questionTitle,
  helpText = "",
  switchh,
  setSwitch,
  newItemError,
  errors,
  triedToSave,
  handleChangeList,
  handleChangueDetailsList,
  handleDeleteFromList,
  handleAddToList,
  setOutsideValue = () => {},
  // Cuando llega { code, isOwn }, el valor se elige de un catalogo en vez de
  // escribirse a mano. El item guarda la etiqueta en `value` y la ruta en
  // `path`, asi las vistas de solo lectura siguen leyendo `value` igual.
  catalogue,
  onCatalogueChange,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const [newItemValue, setNewItemValue] = useState("");
  const [newItemDetails, setNewItemDetails] = useState("");
  const [newItemPath, setNewItemPath] = useState("");
  const [newItemActiveDetails, setNewItemActiveDetails] = useState(false);
  // Remonta el <InputCatalogue> para dejarlo en blanco despues de agregar
  const [catalogueKey, setCatalogueKey] = useState(0);

  useEffect(() => {
    setOutsideValue({
      value: newItemValue,
      details: newItemDetails,
      ...(catalogue && { path: newItemPath }),
    });
  }, [newItemValue, newItemDetails, newItemPath]);

  // El catalogo devuelve la ruta; la etiqueta se resuelve para guardarla junto
  // a ella y que la lista se lea sin volver a consultar el catalogo.
  const handleCataloguePick = async (path) => {
    setNewItemPath(path ?? "");
    setNewItemValue(
      await resolveCatalogueLabel({ ...catalogue, path })
    );
  };

  const handleAdd = () => {
    handleAddToList(id, {
      value: newItemValue,
      details: newItemDetails,
      ...(catalogue && { path: newItemPath }),
    });
    setNewItemValue("");
    setNewItemDetails("");
    setNewItemPath("");
    setNewItemActiveDetails(false);
    setCatalogueKey((prev) => prev + 1);
  }

  const isDisabled = newItemValue.length === 0;

  return (
    <>
      
      <Stack direction="row" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography fontSize={16} fontWeight={600} color="secondary">
            {questionTitle}
          </Typography>
          <HelpIcon text={helpText} sx={{ marginLeft: .5 }} />
        </Box>
        <EGSwitch
          checked={switchh}
          onChange={() => setSwitch(prev=>({...prev, [id]: !prev[id]}))}
          id="locked"
          size="small"
        />
      </Stack>
      
      {
        switchh &&
        <Stack spacing={1.5}>
          {
            data.length > 0 &&
            data.map((item, idx) => (
              <EvaluationListItem
                key={idx}
                idx={idx}
                id={id}
                questionLabel={questionLabel}
                item={item}
                handleChange={handleChangeList}
                handleChangueDetails={handleChangueDetailsList}
                handleDeleteFromList={handleDeleteFromList}
                errors={Array.isArray(errors) ? errors.includes(idx) : false}
                triedToSave={triedToSave}
                catalogue={catalogue}
                onCatalogueChange={onCatalogueChange}
              />
            ))
          }
          <Box display="grid" gridTemplateColumns="1fr 48px" alignItems="center" justifyItems="center" >
            {catalogue ? (
              // InputCatalogue pinta un select POR NIVEL como hermanos. Sin
              // este Box cada nivel cae en su propia celda del grid y el
              // segundo aterriza en la columna de 48px del boton.
              <Box width="100%">
                <InputCatalogue
                  key={catalogueKey}
                  label={questionLabel}
                  catalogue={catalogue.code}
                  isOwn={catalogue.isOwn}
                  showWhenEmpty
                  defaultValue=""
                  onChange={handleCataloguePick}
                  isValid={data.length > 0 ? null : returnIsValid(newItemError, triedToSave)}
                  wrapper={<Box marginBottom={1} />}
                />
              </Box>
            ) : (
              <EGInput
                label={questionLabel}
                value={newItemValue}
                onChange={(e) => setNewItemValue(e.target.value)}
                required={true}
                isValid={data.length > 0 ? null : returnIsValid(newItemError, triedToSave)}
                showSuccessValidation={true}
                showHelpText={false}
              />
            )}
            <EGIconButton
              title={t("Añadir")}
              iconName="add_square"
              iconColor={"ethicsBlue"}
              placement="bottom"
              onClick={isDisabled ? () => {} : handleAdd}
              iconSize={16}
              disabled={isDisabled}
            />
            {
              !newItemActiveDetails &&
              <Link
                onClick={() => setNewItemActiveDetails(true)}
                underline="hover"
                textAlign="end"
                marginTop="3px"
                sx={{ justifySelf: "end" }}
              >
                + {t("evaluation.add_details")}
              </Link>
            }
          </Box>
          {
            newItemActiveDetails && 
            <TextField
              label={t("evaluation.details")}
              value={newItemDetails}
              onChange={(e)=>setNewItemDetails(e.target.value)}
              multiline
              rows={4}
              className="w-100"
            />
          }

        </Stack>
      }

    </>
  )
}